import { render, staticRenderFns } from "./DeleteExtra.vue?vue&type=template&id=ed348036"
import script from "./DeleteExtra.vue?vue&type=script&lang=ts"
export * from "./DeleteExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports